import store from '@polleverywhere/redux'
import { slice as appSlice } from '../../slices/app'
import { html } from 'lit-html'
import { authCodeRedirect } from '../../util/auth_code_redirect'
import { userSource } from '../../util/user_source'

export default async function signup (state, appOptions) {
  const reduxState = store.getState()

  // If we're already logged in, go back or default
  if (appSlice.selectIsFullyLoggedIn(reduxState)) {
    store.dispatch(appSlice.pageUpdatedToDefault())
    return
  }

  // Gate check
  if (!reduxState[appSlice.name].options.allowSignups) {
    store.dispatch(appSlice.pageUpdatedToDefault())
    return
  }

  authCodeRedirect({ initialSignup: true, usrc: userSource() })

  return html``
}
